import React from 'react';
import './UserHeader.css';

const UserHeader = ({ userName, icon, className = '', ...props }) => {
  return (
    <div className={`user-header ${className}`} {...props}>
      <div className="user-header-icon">
        {icon}
      </div>
      <div className="user-header-content">
        <h3 className="user-header-name">
          {userName}
        </h3>
      </div>
    </div>
  );
};

export default UserHeader;
